/**
 * Troca o nome do produto ("Chatwoot") pelo nome da instalação.
 *
 * Fonte única para os dois caminhos que fazem essa troca:
 *   - `dashboard/i18n/applyInstallationName.js` — percorre a árvore de mensagens
 *     uma vez no boot (dashboard, ~40 idiomas);
 *   - `shared/composables/useBranding.js` — troca string a string em runtime
 *     (widget e survey, que têm i18n próprio).
 *
 * Manter as duas com regex própria já custou caro: a do useBranding era
 * `/chatwoot/gi` e teria corrompido URLs e identificadores no dia em que
 * alguma string com URL passasse por ela.
 *
 * Duas garantias, e ambas são necessárias:
 *
 * 1. **Case-sensitive.** Só o "Chatwoot" capitalizado é texto de marca. O
 *    minúsculo aparece em URLs (`chatwoot.com`, `app.chatwoot.com/hc/…`,
 *    `chatwoot.help`) e em identificadores (`window.chatwootSettings`, o
 *    snippet do widget que o cliente cola no site dele). O caso mais traiçoeiro
 *    é `signup.json:TERMS_ACCEPT`: a URL do chatwoot.com ali é um placeholder
 *    que `Signup/Form.vue` substitui por `TERMS_URL` com um `.replace()`
 *    literal — reescrevê-la faria o replace não casar e os links de Termos e
 *    Privacidade apontariam para o Chatwoot, em silêncio.
 *
 * 2. **Placeholders de interpolação são preservados.** `{latestChatwootVersion}`
 *    (GENERAL_SETTINGS.UPDATE_CHATWOOT, 54 idiomas) também é capitalizado.
 *    Renomeá-lo quebra o binding que o componente entrega ao `$t`. O texto fora
 *    das chaves continua sendo trocado, então formas sufixadas de línguas
 *    aglutinantes — `Chatwootban` (hú), `Chatwootiga` (et) — seguem funcionando.
 */
const PRODUCT_NAME = /Chatwoot/g;
const PLACEHOLDER = /(\{[^}]*\})/;

export const renameProduct = (text, name) => {
  if (!text || !name) return text;

  return text
    .split(PLACEHOLDER)
    .map(part =>
      /^\{[^}]*\}$/.test(part) ? part : part.replace(PRODUCT_NAME, name)
    )
    .join('');
};

export default renameProduct;
